import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class PushService {
  private VAPID_PUBLIC = environment.webpushVapidKey; // base64 url-safe

  constructor(private http: HttpClient) {}

  async init(): Promise<PushSubscription | null> {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
      console.warn('Push not supported');
      return null;
    }

    // register SW (must be at site root)
    const reg = await navigator.serviceWorker.register('/push-sw.js');
    // get existing subscription
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      const convertedVapidKey = this.urlBase64ToUint8Array(this.VAPID_PUBLIC);
      // use the underlying ArrayBuffer (cast to satisfy TS DOM definitions)
      const applicationServerKey = convertedVapidKey.buffer as ArrayBuffer;
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey
      });
    }
    // send sub to server
    await this.http.post(`${environment.apiBaseUrl}/subscribe`, sub).toPromise();
    return sub;
  }

  // Helper: converts base64 url-safe VAPID key to Uint8Array
  private urlBase64ToUint8Array(base64String: string): Uint8Array {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }
}